// Explicit extension (rather than a bare specifier) so this module resolves
// under plain `node --test` as well as through Vite — see nextStepResolver.js.
import { intersection } from './setUtils.js'

export const hasRole = (user, roles) =>
    intersection(new Set(user.roles), new Set(roles)).size > 0
